import { render } from "./CalculatorBocal.vue?vue&type=template&id=52294be5&scoped=true"
import script from "./CalculatorBocal.vue?vue&type=script&lang=js"
export * from "./CalculatorBocal.vue?vue&type=script&lang=js"

import "./CalculatorBocal.vue?vue&type=style&index=0&id=52294be5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52294be5"]])

export default __exports__